import { IErrorBaseProps } from '../components/itemsError/ItemError';
import { ControlFacet } from '../models/controls/ControlFacet';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';
import { IItemCacheThunkAction } from '../store/actions/ItemCacheActions';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';

/**
 * @public
 */
export interface IItemErrorRendererProps extends IErrorBaseProps {
    itemKey?: string | undefined;
}

/**
 * @public
 */
export interface IItemErrorControlProps {
    itemKey: string | undefined;
    error: Error;
}

/**
 * @public
 */
export interface IItemErrorControlOverrides {
    /**
     * Override for the component which renders when there is an error.
     */
    errorRenderer: React.ComponentType<IComponentAsProps<IItemErrorRendererProps>>;
    /**
     * Creator for an action which, when dispatched, handles the error in an application-specific manner.
     */
    onError: (payload: {
        itemKey: string;
        error: Error;
    }) => IItemCacheThunkAction<void>;
}

/**
 * @public
 */
export const itemErrorControl: ControlFacet<IItemErrorControlProps, IItemErrorControlOverrides> =
    new ControlFacet<IItemErrorControlProps, IItemErrorControlOverrides>('itemErrorControl', {
        errorRenderer: defaultRenderComponentOption<IErrorBaseProps>()
    });
